import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';
import { useIdentity } from '@bonusly/who-am-i';

import { headers } from '../../../queries/meta';

interface CelebrationsData {
	receiveAnniversaryBonus: boolean;
	hiredOn: string | null;
	privateAnniversaryPost: boolean;
	receiveBirthdayBonus: boolean;
	dateOfBirth: string | null;
	privateBirthdayPost: boolean;
}

interface CelebrationsEditability {
	hasBirthdayBot: boolean;
	hasAnniversaryBot: boolean;
	hiredOnEditable: boolean;
	dateOfBirthEditable: boolean;
}

interface CelebrationsResponse {
	celebrations: CelebrationsData;
	editability: CelebrationsEditability;
}

type CelebrationsUpdateParams = Partial<CelebrationsData>;

export const useCelebrations = () => {
	const http = useHttpClient();

	return useQuery({
		queryKey: ['user', 'celebrations'],
		queryFn: async () => {
			const res = await http.get<CelebrationsResponse>('/me/celebrations', { headers });
			return res.data;
		},
	});
};

export const useUpdateCelebrations = () => {
	const http = useHttpClient();
	const { refetchProfile } = useIdentity();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (data: CelebrationsUpdateParams) => {
			const res = await http.put<CelebrationsResponse>('/me/celebrations', data, { headers });
			await refetchProfile();
			return res.data;
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['user', 'celebrations'] });
		},
	});
};
